import { Typography } from "@mui/material";

const Heading = () => {
  return (
    <Typography
      variant="h1"
      color="text.primary"
      textAlign="center"
      mb={{ xs: 3, md: 8, lg: 12.5 }}
      maxWidth={1140}
      mx="auto"
    >
      From inquiry to insight — how to get{" "}
      <Typography
        component="span"
        fontSize="inherit !important"
        fontWeight="inherit !important"
        fontFamily="inherit !important"
        color="text.accent"
      >
        Trackmate{" "}
      </Typography>
      in a few simple steps
    </Typography>
  );
};

export default Heading;
